const automaticStatuses = new Set(["", "pending", "overdue", "unpaid", "assumed_paid"]);

const businessDate = (date) => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kuala_Lumpur", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(date);
  const value = (type) => parts.find((part) => part.type === type)?.value;
  return `${value("year")}-${value("month")}-${value("day")}`;
};

export const getRepaymentStatus = (repayment, now = new Date()) => {
  const status = String(repayment?.status || "").trim().toLowerCase();
  if (["paid", "done"].includes(status) || repayment?.paid_at || repayment?.repay_date) return "paid";
  const dueDate = String(repayment?.due_date || repayment?.repay_due_date || "").slice(0, 10);
  if (!automaticStatuses.has(status) || !/^\d{4}-\d{2}-\d{2}$/.test(dueDate) || Number.isNaN(Date.parse(dueDate))) {
    return status || "pending";
  }
  return dueDate < businessDate(now) ? "assumed_paid" : "pending";
};

export const isRepaymentSettled = (repayment, now) =>
  ["paid", "assumed_paid"].includes(getRepaymentStatus(repayment, now));

export const repaymentStatusLabel = (repayment, now) => {
  const status = getRepaymentStatus(repayment, now);
  if (status === "assumed_paid") return "Assumed Paid";
  return status.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
};
